import OverlayScrollbars from 'overlayscrollbars';
import { useEffect, useRef } from 'react';

const OverlayScrollbarsComponent = (props) => {
  const { options, extensions, scrollbarRef, wrapperRef, ...otherProps } =
    props;

  const target = useRef(null);
  const scrollbar = useRef(null);

  useEffect(() => {
    scrollbar.current = OverlayScrollbars(
      target.current,
      options || {},
      extensions
    );
    if (scrollbarRef) {
      scrollbarRef.current = scrollbar.current;
    }
    if (wrapperRef) {
      wrapperRef.current = target.current;
    }
    return () => {
      scrollbar.current.destroy();
    };
  }, [extensions, scrollbarRef, wrapperRef, options]);

  useEffect(() => {
    if (scrollbar.current) {
      scrollbar.current.options(options);
    }
  }, [options]);

  return (
    <div {...otherProps} ref={target}>
      {props.children}
    </div>
  );
};

export default OverlayScrollbarsComponent;
